
import {defineComponent} from "vue";

export default defineComponent({
  emits: ["click"],

  props: {
    title: {
      type: String
    },

    description: {
      type: String
    },

    background: {
      required: true,
      type: String
    },

    watched: {
      type: Boolean
    }
  },

  setup(_props, { emit }) {
    let pressed = false;
    let moved = false;
    let released = false;

    /** note: is it really necessary to pass the events as params? */

    const pressing = () => {
      pressed = true;
    };

    const moving = () => {
      if (!pressed) {
        return;
      }
      moved = true;
    };

    const releasing = e => {
      released = true;
      const context = e.button == 2;

      if (released && !moved && !context) {
        emit("click", e);
      }

      pressed = false;
      moved = false;
      released = false;
    };

    return {
      moving,
      pressing,
      releasing
    };
  }
});
